module.exports = __webpack_public_path__ + "img/title4.a141dcae.jpg";